import React from 'react'
import { styled } from 'baseui'
import PageTitle from '@components/PageTitle'
import ErrorSign from '@assets/cross-circle.svg'
import Button from '@wemolo/ui/components/Buttons/Button'
import { useTranslation } from 'react-i18next'
import { BUTTON_KIND, BUTTON_SHAPE, BUTTON_SIZE } from '@wemolo/ui/components/Buttons/types'
import { useHistory, useLocation } from 'react-router-dom'
import { errorCodeMapper, ErrorKeys } from '@utils/errors'

const PageContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale900
}))

const MainContentContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale1600,
    alignItems: 'center',
    textAlign: 'center'
}))

const LogoContainer = styled('div', () => ({
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
}))

const Error = () => {
    const { t } = useTranslation(['serverErrors'])
    const history = useHistory()
    const location = useLocation()

    const queryParams = new URLSearchParams(location.search)
    const errorCode = queryParams.get('errorCode')

    const errorMessage = errorCodeMapper[errorCode as ErrorKeys]

    if (errorMessage) {
        console.error(errorMessage)
    }

    const onButtonClick = () => {
        history.push('/')
    }

    return (
        <PageContainer>
            <LogoContainer>
                <div>
                    <ErrorSign />
                </div>
            </LogoContainer>
            <PageTitle>{t('tryAgainTitle')}</PageTitle>
            <MainContentContainer>
                <div>{t(errorMessage || 'tryAgainMessage')}</div>
                <Button
                    $shape={BUTTON_SHAPE.pill}
                    $kind={BUTTON_KIND.primary}
                    $size={BUTTON_SIZE.medium}
                    overrides={{ BaseButton: { style: { width: '100%' } } }}
                    onClick={onButtonClick}
                >
                    {t('common.exit')}
                </Button>
            </MainContentContainer>
        </PageContainer>
    )
}

export default Error
